export default "__VITE_ASSET__Buail9Ag__"